const MESSAGES = {
  SETTINGS_SAVED_SUCCESS: "Settings saved successfully.",
  ALARMS_SAVED_SUCCESS: "Alarms saved successfully.",

  TELEGRAM_BOT_ACTIVATED: "Telegram bot activated.",
  TELEGRAM_BOT_DISABLED: "Telegram bot disabled.",

  AVATAR_UPLOADED_SUCCESSFULLY: "Avatar Uploaded successfully",
  AVATAR_UPLOAD_FAILED: "Uploading the avatar get failed!",

  SOCKET_CONNECT_FAILED:
    "The attempt to connect to the server failed, please try again.",
  IO_SERVER_DISCONNECT: "Your connection was disconnected from the server !",
  IO_CLIENT_DISCONNECT: "Your connection with the server has been interrupted!",

  REDIRECT_TO_LOGIN: "Redirecting to login page",

  CONV_CLOSED: "Conversation closed.",
  CONV_REJECTED: "Conversation rejected.",
  NEW_PRETEXT_ADDED: "The message added successfuly.",
  PRETEXT_REMOVED: "The message removed successfuly.",
  PRETEXT_EDITED: "The message edited successfuly.",
  USER_INFO_SAVED: "The user information saved.",

  CHECK_YOUR_CONNECTION: "Please check your internet connection and try again.",

  RECOVERY_EMAIL_SENT:
    "The recovery email has been sent, please login to the app with sent password.",
  EMAIL_NOT_FOUND: "Email not found.",

  SETTING_UP_APP: "Setting up the app environment",
  RECONNECTING: "Reconnecting ...",
  ALLOW_NOTIFICATION:
    "Allow browser notifications for getting the app notification",
  EXPIRE_PACKAGE_ALERT: "Your package has expired",
  ROUTER_FALLBACK_TEXT: "Loading ...",

  COPIED: "Copied",
  COPY_FAILED: "Something went wrong while copying the text! Try again.",

  EMAIL_ID_REQUIRED: "Email is required",
  EMAIL_IS_INVALID: "Email is invalid",
  PASSWORD_IS_REQUIRED: "Password is required",

  // handleRequestErrors
  SERVER_ERROR: "Something went wrong in the server! please try again.",
  WRONG_ENTERED_INFO: "Wrong entered information!",
  TOO_MANY_REQUEST: "Too many requests!",

  INVALID_FILE_FORMAT: "The file format is invalid",
  Image_SIZE_EXCEEDS: "Image size should be less than 500 KB",

  OPERATION_FAILED: "Operation failed",

  BLOCK_ACCEPT_CONV_FOR_EXPIRE_PACKAGE:
    "To accept this conversation please renew your package.",
  BLOCK_ACCEPT_CONV_FOR_NOT_ENOUGH_CHARGE:
    "To accept this conversation please charge your package's conversation.",

  BLOCK_START_CONV_FOR_EXPIRE_PACKAGE:
    "To start this conversation please renew your package",
  BLOCK_START_CONV_FOR_NOT_ENOUGH_CHARGE:
    "To start this conversation please charge your package's conversation.",

  CHOOSE_RANGE_FOR_BLOCK: "Please choose the range you want to block the user",

  YOUR_BROWSER_NOT_SUPPORT_NOTIFS:
    "Your browser does not support notif messages",
  PROBLEM_WHILE_ACTIVATING_NOTIFS:
    "There was a problem activating notifications.",
  NOTIF_ENABLE_ACCESS_BLOCKED:
    "Access to sending notifications is blocked, please enable notifications through the browser",
  NOTIF_NOT_SUPPORTED: "Your browser does not support notifications",
  NOTIFS_ENABLED: "Notifications enabled",
  ERROR_WHILE_ENABLING_NOTIFS:
    "There was a problem activating your notifications.",
  NO_ROADMAP_RECORDED: "No roadmap is recorded for this user",
  CONVERSATION_EXPIRED:
    "The selected conversation has expired. To restore the conversation, contact support.",
  FILE_UPLOAD_SERVER_ERROR:
    "Server Error: Something went wrong while uploading!",
  FILE_UPLOAD_FAILED: "Upload Failed! Please try again.",

  VERIFY_CODE_SUCCESSFULLY_SEND_TO_YOUR_EMAIL:
    "Verification code has been successfully sent to your email!",
  VERIFY_CODE_SUCCESSFULLY_SEND_TO_YOUR_PHONE:
    "Verification code has been successfully sent to your phone number!",

  CONTENT_NOT_FOUND: "No content found for your request!",
  WRONG_ENTERED_CODE: "The entered code is incorrect!",
  WRONG_ENTERED_EMAIL: "The entered email is not valid!",
  WRONG_ENTERED_PHONE: "The entered phone number is not valid!",
  SENT_REQUEST_NOT_CORRECT: "The request sent is not correct.",

  FILE_SIZE_MORE_THAN_MAX: "To upload bigger files, upgrade your account",

  BLOCK_USER_SUCCESS:
    "The desired user has been successfully added to the blacklist",
  BLOCK_USER_ERROR_DUPLICATE: "This user has already been blacklisted",

  USER_UNBLOCKED_SUCCESS: "User successfully removed from blacklist",
};

export default MESSAGES;
